module.exports = __webpack_public_path__ + "agency-analytics-logo-de2c2558a64ea20b37b291b44acd4f7d.svg";